import Vue from 'vue'
import VueRouter from 'vue-router'
// import axios from 'axios'
// import store from '../store/index'
import {
  getUrlParam
} from '@/common/utils.js'

const Tabbar = () => import(/* webpackChunkName:"login_School_Tabbar" */ '../components/Tabbar.vue')

const Index = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Index.vue')
const My = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/My.vue')
const Login = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Login.vue')
const MyBankCard = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/MyBankCard.vue')
const RepaymentDetails = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/RepaymentDetails.vue')
const Payment= () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Payment.vue')
const newrepayment= () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/newrepayment.vue')
const Details = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Details.vue')
const Repayment = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Repayment.vue')
const Cash = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Cash.vue')
const PhotoProofs = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/PhotoProofs.vue')
const PersonalDetails = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/PersonalDetails.vue')
const CompanyDetails = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/CompanyDetails.vue')
const BankDetails = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/BankDetails.vue')
const firstCashDetail = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/firstCashDetail.vue')

Vue.use(VueRouter)

const routes = [{
  path: '/tabbar',
  component: Tabbar,
  redirect: '/index',
  children: [{
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      title: 'mak rupee'
    }
  },
  {
    path: '/cash',
    name: 'cash',
    component: Cash,
    meta: {
      title: 'mak rupee'
    }
  },
  {
    path: '/my',
    name: 'my',
    component: My,
    meta: {
      title: 'mak rupee'
    }
  }
  ]
},
{
  path: '/mybankcard',
  name: 'mybankcard',
  component: MyBankCard,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/bankdetails',
  name: 'bankdetails',
  component: BankDetails,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/photoproofs',
  name: 'photoproofs',
  component: PhotoProofs,
  meta: {
    title: 'mak rupee'
  }
},

{
  path: '/repayment',
  name: 'repayment',
  component: Repayment,
  meta: {
    title: 'mak rupee'
  }
},

{
  path: '/firstcashdetail',
  name: 'firstcashdetail',
  component: firstCashDetail,
  meta: {
    title: 'mak rupee'
  }
},

{
  path: '/personaldetails',
  name: 'personaldetails',
  component: PersonalDetails,
  meta: {
    title: 'mak rupee'
  }
},

{
  path: '/companydetails',
  name: 'companydetails',
  component: CompanyDetails,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/repaymentdetails',
  name: 'repaymentdetails',
  component: RepaymentDetails,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/payment',
  name: 'payment',
  component: Payment,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/newrepayment',
  name: 'newrepayment',
  component: newrepayment,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/details',
  name: 'details',
  component: Details,
  meta: {
    title: 'mak rupee'
  }
},
{
  path: '/login',
  name: 'login',
  component: Login,
  meta: {
    title: 'mak rupee'
  }
}
]

const router = new VueRouter({
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const firstPath = to.path
  console.log(firstPath)
  if (firstPath === '/err' || firstPath === '/follow' || firstPath === '/index' || firstPath === '/my' || firstPath === '/order') {
    next()
  } else if (firstPath === '/dowxlogin') {
    const token = window.localStorage.getItem('token')
    var appid = getUrlParam('appid')
    var url = getUrlParam('url')
    if (!url) url = 'index'
    if (token) {
      next(url)
    } else {
      window.location.href = 'http://www.food.jiaowushu.com/index/dologin?appid=' + appid + '&url=' + url
    }
  } else if (firstPath === '/setToken') {
    const token = getUrlParam('token')
    const url = getUrlParam('url')
    if (token) {
      console.log('url')
      console.log(url)
      window.localStorage.setItem('token', token)
      next(url)
    } else {
      next('/err')
    }
  } else {
    const invitor = getUrlParam('invitor')
    window.sessionStorage.setItem('invitor', invitor)
    if (firstPath === '/') {
      next('/index')
    } else {
      next()
    }
    // if (!store.state.schoolInfo) {
    //   axios.get('user/detail').then(function (res) { // 获取用户基本信息
    //     if (res.data.code === 200) {
    //       store.commit('editUserInfo', res.data.data)
    //       if (firstPath === '/') {
    //         next('/index')
    //       } else {
    //         next()
    //       }
    //     } else {
    //       next('/err')
    //     }
    //   }).catch(function (error) {
    //     console.log(error)
    //   })
    // } else {
    // }
  }
})

export default router
